module.exports = __webpack_public_path__ + "img/3.d485756b.png";